const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMWE1IDUgMCAwIDEgNSA1djJoLTJWNmEzIDMgMCAwIDAtNiAwdjVoOWEyIDIgMCAwIDEgMiAydjhhMiAyIDAgMCAxLTIgMkg2YTIgMiAwIDAgMS0yLTJ2LThhMiAyIDAgMCAxIDItMmgxVjZhNSA1IDAgMCAxIDUtNXptNiAxMkg2djhoMTJ2LTh6bS02IDNhMSAxIDAgMSAxIDAgMiAxIDEgMCAwIDEgMC0yeiIgIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export {
  I as default
};
//# sourceMappingURL=unlock-c911b39a.mjs.map
